/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetBankAccountDto } from '../models/AssetBankAccountDto';
import type { CreateAssetBankAccountRequest } from '../models/CreateAssetBankAccountRequest';
import type { UpdateAssetBankAccountRequest } from '../models/UpdateAssetBankAccountRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AssetBankAccountControllerService {
  /**
   * listByCategory
   * @returns AssetBankAccountDto OK
   * @throws ApiError
   */
  public static listByCategoryUsingGet({
    categoryId,
  }: {
    /**
     * categoryId
     */
    categoryId: string;
  }): CancelablePromise<Array<AssetBankAccountDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/asset-bank-account/category/{categoryId}',
      path: {
        categoryId: categoryId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * addBankAccount
   * @returns AssetBankAccountDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static addBankAccountUsingPost({
    categoryId,
    request,
  }: {
    /**
     * categoryId
     */
    categoryId: string;
    /**
     * request
     */
    request: CreateAssetBankAccountRequest;
  }): CancelablePromise<AssetBankAccountDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/asset-bank-account/category/{categoryId}',
      path: {
        categoryId: categoryId,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateBankAccount
   * @returns AssetBankAccountDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateBankAccountUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: UpdateAssetBankAccountRequest;
  }): CancelablePromise<AssetBankAccountDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/asset-bank-account/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteBankAccount
   * @returns any OK
   * @throws ApiError
   */
  public static deleteBankAccountUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/asset-bank-account/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
